// extracted by mini-css-extract-plugin
module.exports = {"root":"CategoryService_root__131QX","label":"CategoryService_label__24tzO","location":"CategoryService_location__2ny78"};